import { inject, Injectable } from '@angular/core';
import { SqliteService, SyncService } from '@app/services';
import { JsonSQLite } from '@capacitor-community/sqlite';
import { RouteModel } from '@app/models';
import { PaymentRepository } from './payment.repository';
import { CartRepository } from './cart.repository';
import { ReturnRepository } from './return.repository';
import { CheckInRepository } from './check-in.repository';
import { RouteRepository } from './route.repository';
import { UserRepository } from './user.repository';

@Injectable({
    providedIn: 'root',
})
export class SyncRepository
{
    private sqliteService = inject(SqliteService);
    private syncService = inject(SyncService);
    private userRepository = inject(UserRepository);
    private paymentRepository = inject(PaymentRepository);
    private cartRepository = inject(CartRepository);
    private returnRepository = inject(ReturnRepository);
    private checkInRepository = inject(CheckInRepository);
    private routeRepository = inject(RouteRepository);

    async syncDataWithServer(data: JsonSQLite, isOverdue: boolean): Promise<{ status: boolean, message: string, }>
    {
        return await this.syncService.sync(data, isOverdue);
    }

    async getSyncData(): Promise<JsonSQLite | null>
    {
        return await this.sqliteService.exportToJSON();
    }

    async clearSyncedData()
    {
        await this.sqliteService.deleteDatabase();
        await this.userRepository.logout();

        // await this.cartRepository.clearUserRouteCartItems(route.id);
        // await this.returnRepository.clearUserRouteReturnItems(route.id);
        // await this.paymentRepository.clearUserRoutePayments(route.id);
        // await this.checkInRepository.clearUserRouteCheckIns(route.id);
        // await this.routeRepository.clearUserRoute(route);
    }
}
